import { Component } from '@angular/core';

@Component({
  selector: 'mt-faq-section',
  templateUrl: './faq-section.component.html',
  styleUrls: ['../home.component.scss', './faq-section.component.scss'],
})
export class FaqSectionComponent {}
